const datepickerTemplateUrl = require('./datepicker.html');
const dayTemplateUrl = require('./day.html');

const app = angular.module('msi.datepicker', ['pascalprecht.translate']);

app.run(['$templateCache', ($templateCache) => {
  $templateCache.put('uib/template/datepicker/datepicker.html', $templateCache.get(datepickerTemplateUrl));
  $templateCache.put('msi/datepicker/day.html', $templateCache.get(dayTemplateUrl));
}]);

app.filter('ogDayLocale', require('./day-locale-filter'));

module.exports = app.name;
